import fetch from '@frontastic/bridge/js/fetch';

async function addKlaviyoSubscriber({
  email,
  firstName,
  lastName,
  csrf_token,
}) {
  const removeFalsyValues = (obj) => {
    const newObj = {};
    Object.keys(obj).forEach((key) => {
      if (obj[key]) newObj[key] = obj[key];
    });
    return newObj;
  };

  try {
    const data = {
      email,
      csrf_token,
      first_name: firstName,
      last_name: lastName,
    };
    const params = removeFalsyValues(data);
    const res = await fetch('/custom_api/klaviyo/subscriber/add', {
      method: 'POST',
      body: JSON.stringify({...params}),
    });
    return res.json();
  } catch (err) {
    throw new Error(err);
  }
}

export default addKlaviyoSubscriber;
